import styled from 'styled-components'
import { Card, Typography } from '@material-ui/core'
import { colors } from '../../../../../shared/styles/colors'

interface IContentProps {
  justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline'
  alignContent?:
    | 'stretch'
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline'
}
export const ContainerCards = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  height: 100%;
  margin: 20px 30px;

  @media (max-height: 1080px) {
    height: 400px;
    flex: 1;
  }
`

export const Title = styled(Typography)`
  font-family: 'Inter', Roboto, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: #6d787d;
`

export const StyledCard = styled(Card)`
  min-height: 70vh;
`

export const Content = styled.div<IContentProps>`
  display: flex;
  padding: 18px;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  align-content: ${props => props.alignContent};
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;

  border-top: 1px solid white;
  width: 100%;
  padding: 0px 16px 16px 16px;
  button {
    margin-top: 30px;
  }
`
